/**
 *
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
 *
 */

export default {
  path: "/app/config/sync",
  name: "SYNC",
  component: () => import("@/app/views/crud/CrudSimpleView.vue"),
  meta: {
    service: () => import("@/app/services/SyncService"),
    table: () => import("@/app/components/config/sync/SyncTable.vue"),
    form: () => import("@/app/components/config/sync/SyncForm.vue"),
    header: {
        icono: 'mdi-sync-circle',
        texto: 'Sincronización',
        textNew: 'Registrar',
        textEdit: 'Modificar'
    },
    prm: "ND",
    requireAuth: true,
    hideButtonAdd: true
  },
};
